<app-card class="group h-full transition-all duration-300">
  <a
    app-card-content
    class="flex h-[inherit] cursor-pointer justify-center"
    [routerLink]="['/trilhas-de-aprendizagem/cursos']"
  >
    <img class="h-full w-auto rounded-2xl shadow-lg shadow-black/20 group-hover:opacity-80" [src]="image$ | async" />
  </a>
</app-card>
